import styles from "../detalheEsocial.styles.module.css";
import { LARGURA_REGUA, mesesDaEscala } from "../utils/vigenciaRubrica.util";

/** TXM-671 — régua de anos do cabeçalho da coluna "Período de vigência" (mesma largura da célula). */
export default function ReguaAnos({ escala }) {
  const meses = mesesDaEscala(escala);
  if (!meses.length) return null;
  const porAno = meses.reduce((acc, m) => {
    const ano = m.slice(0, 4);
    acc[ano] = (acc[ano] || 0) + 1;
    return acc;
  }, {});
  return (
    <div className={styles.reguaAnos} style={{ width: LARGURA_REGUA }} aria-hidden="true">
      {Object.entries(porAno).map(([ano, n]) => (
        <span key={ano} style={{ width: `${(n / meses.length) * 100}%` }}>
          {ano}
        </span>
      ))}
    </div>
  );
}
